import { MedianovaImage } from "./medianova-image";

export default function medianovaLoader({
  src,
  width,
}: {
  src: string;
  width: number;
  quality: number;
}): string {
  const image = new MedianovaImage(src);
  return image.resize(width, "-");
}
